Lesson: What is STXT
	Progress: 2/5
	Explanation >>
		**STXT** is a format (or language)
		for indentation-based documents.
		The indentation defines the hierarchy
		of the document.

		This is not XML. This is not YAML.
		The closest one is XML, as you have nodes,
		namespaces and schemas. And on the surface
		it looks like some sort of YAML. But this
		is a different language.

		There are two types of nodes: **Inline and Block**

	Inline node: everything after ':' is the value of the node

	Block node >>
		All the content of
		the block node is raw text.
		No escape characters: all the content
		is taken "as is".
		You can put whatever you like.

		A block node inside a block?
		Block node inside >>
			NOOO!! Inside 'Block node'
			everything is text. No rules here.
			No more blocks here.

	Another node: You can have all the nodes you want
		Inner node: This is a child of 'Another node'
		Inner node: You can repeat the name 'Inner node'
